// VERSÃO 15.0 - SNIPER API CLIENT (SUPREMACIA TÁTICA)

import axios from 'axios';

// 🛡️ CHAVES DE BRIDGE (Sincronizadas com o Sniper Security no Compose)
const SNIPER_API_KEY = "UMA_CHAVE_SECRETA_PARA_PROTEGER_O_REGISTRO_MASTER";

const apiClient = axios.create({
    baseURL: '/', // O Nginx faz o roteamento inteligente (Portas 7709, 7712, etc)
    timeout: 60000, // 🚀 AUMENTADO PARA 60s: Essencial para upload de imagens 4K
    headers: {
        'Accept': 'application/json'
    }
});

/* ==========================================================
    🎯 INTERCEPTOR DE REQUISIÇÃO (INJEÇÃO DE PATENTE)
========================================================== */
apiClient.interceptors.request.use(config => {
    const url = config.url;
    const userToken = localStorage.getItem('token');

    // 🔐 IDENTIFICAÇÃO DE ALVO (SNIPER SECURITY BRIDGE)
    // Injetamos as chaves se o alvo for gestão de usuários ou auditoria de sistema
    if (url.includes('/api/users') || url.includes('/api/auth') || url.includes('/sys/')) {
        config.headers['x-api-key'] = SNIPER_API_KEY;
        config.headers['x-bridge-key'] = SNIPER_API_KEY;
        // console.log(`🚀 [UPLINK-SECURE]: ${url}`);
    }

    // 🔑 INJEÇÃO DO TOKEN JWT DO OPERADOR
    if (userToken) {
        config.headers.Authorization = `Bearer ${userToken}`;
    }

    return config;
}, error => {
    return Promise.reject(error);
});

/* ==========================================================
    🛰️ INTERCEPTOR DE RESPOSTA (CAIXA PRETA DE ERROS)
========================================================== */
apiClient.interceptors.response.use(
    response => response,
    error => {
        // Extração de Inteligência do Erro
        const serverData = error.response?.data;
        const status = error.response?.status;
        
        const errorInfo = {
            status: status || 'TIMEOUT_OU_CONEXAO',
            url: error.config?.url,
            method: error.config?.method?.toUpperCase(),
            // Prioriza a mensagem técnica do servidor para o debug
            message: serverData?.message || serverData?.error || error.message,
            details: serverData?.details || null,
            timestamp: new Date().toLocaleTimeString()
        };

        // 🎯 LOG DE ELITE NO CONSOLE (Visível para o Comandante)
        console.group(`❌ [API-ERROR] ${errorInfo.method} -> ${errorInfo.url}`);
        console.error("STATUS TÁTICO:", errorInfo.status);
        console.error("MENSAGEM:", errorInfo.message);
        
        if (errorInfo.details) {
            console.warn("DETALHES DO SCHEMA:", errorInfo.details);
        }

        // ⚠️ Detecção de Crash do Servidor (HTML de Manutenção)
        if (typeof serverData === 'string' && serverData.includes('<!DOCTYPE html>')) {
            console.error("🚨 ALERTA: O Servidor crashou e entregou HTML. Verifique o log do Docker!");
        }
        console.groupEnd();

        // Tratamentos de Protocolo
        if (status === 401) {
            console.warn("🚩 PATENTE EXPIRADA: Token JWT Inválido.");
            // Opcional: window.location.href = '/login';
        }

        if (status === 403) {
            console.error("🚫 ACESSO NEGADO: Sua patente não permite este alvo.");
        }

        return Promise.reject(errorInfo);
    }
);

export default apiClient;